<template>
  <iframe
    sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
    allowfullscreen="true"
    :src="src"
    :style="{
      display: 'block',
      border: 'none',
      position: 'absolute',
      width: '100%',
      height: 'calc(100dvh - var(--nav-height) - 48px)'
    }"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://ananda.analytics.enterprise.zwiz.app/${this.currentLang}/url-tracking`
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/UrlTrackingIframe.vue